import { useSelector } from 'react-redux'
import { modelSelector } from 'services/channelSettings/slice'

export function useCompanyHasFeature(feature) {
  const model = useSelector(modelSelector)

  return model?.featureFlags?.includes(feature)
}
